export const QUOTE_MODE_KEY = 'unit-quote-mode';

export function deriveQuoteMode({ orderInstallationDetails, localFlag } = {}) {
  const recordIsQuote = orderInstallationDetails?.isQuotesOrder === true;
  const isQuote = recordIsQuote || Boolean(localFlag);
  const isDraftQuote = isQuote && orderInstallationDetails?.IsDraft === true;
  return { isQuote, isDraftQuote };
}

export function buildQuoteListQuery({ page, paginate, sort, listParamState = {} }) {
  const p = listParamState;
  return (
    `PageIndex=${page}&PageSize=${paginate}&sort=${sort}` +
    `&FilterIsDeleted=false&IsQuotesOrder=true&IsDraft=true` +
    (p.isCustomerQuote ? `&isCustomerQuote=true` : '') +
    (p.sortOn ? `&sortOn=${p.sortOn}` : '') +
    (p.jobNumber ? `&JobNo=${p.jobNumber}` : '') +
    (p.shipToPropertyName ? `&ShipToPropertyName=${p.shipToPropertyName}` : '') +
    (p.StoreId ? `&Store=${p.StoreId}` : '') +
    (p.unitName ? `&UnitName=${p.unitName}` : '') +
    (p.salesPerson ? `&salesPerson=${p.salesPerson}` : '') +
    (p.installationDate ? `&OrderInstallationDate=${p.installationDate}` : '') +
    (p.installationEndDate ? `&OrderInstallationEndDate=${p.installationEndDate}` : '') +
    (p.itemName ? `&itemName=${encodeURIComponent(p.itemName)}` : '')
  );
}
